import { render } from "./OrderDocumentsModal.html?vue&type=template&id=f5b1843a&scoped=true"
import script from "./OrderDocumentsModal.js?vue&type=script&lang=js"
export * from "./OrderDocumentsModal.js?vue&type=script&lang=js"

import "./OrderDocumentsModal.css?vue&type=style&index=0&id=f5b1843a&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5b1843a"]])

export default __exports__